"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerView = void 0;
const View_1 = require("../core/render/View");
const Resource_1 = require("../core/resourceSystem/Resource");
const viewModelCollection_1 = require("../viewModelCollection");
const AudioWidget_1 = require("./widgets/AudioWidget");
const ButtonWidget_1 = require("./widgets/ButtonWidget");
const HtmlWidget_1 = require("./widgets/HtmlWidget");
class PlayerView extends View_1.View {
    constructor() {
        super();
        this.dataContext = viewModelCollection_1.getPlayerViewModel();
        this.dataContext.title = null;
        let container = document.createElement("div");
        container.classList.add("player");
        container.style.marginTop = "40px";
        this.renderBody = container;
        let hideButton = new ButtonWidget_1.ButtonWidget();
        hideButton.parentWidget = this;
        hideButton.text = "Show Player";
        hideButton.addOnClickEvent(() => this.dataContext.togglePlayer.run(null));
        this.widgets.push(hideButton);
        let playerDiv = new HtmlWidget_1.HtmlWidget("div", "");
        playerDiv.parentWidget = this;
        playerDiv.element.classList.add("invisible");
        this.dataContext.togglePlayerEvent = () => {
            playerDiv.element.classList.toggle("invisible");
            if (!playerDiv.element.classList.contains("invisible")) {
                container.style.opacity = "1";
            }
            else {
                container.style.opacity = ".75";
            }
            hideButton.text = `${playerDiv.element.classList.contains("invisible") ? "Show" : "Hide"} Player`;
        };
        let audio = new AudioWidget_1.AudioWidget();
        audio.parentWidget = this;
        let audioSource = document.createElement("source");
        audio.renderBody.appendChild(audioSource);
        playerDiv.widgets.push(audio);
        this.widgets.push(playerDiv);
        this.dataContext.songManager.songSwitched = (song) => __awaiter(this, void 0, void 0, function* () {
            let resource = yield this.dataContext.resourceManager.getResource(song.audioStreamResourceId);
            this.dataContext.logger.logDebug(`[Player]: Audio resource loaded. Resource Name: ${resource.resourceName}`);
            if (resource.resourceType === Resource_1.ResourceType.Url) {
                audioSource.src = resource.resourceBody;
            }
            else if (resource.resourceType === Resource_1.ResourceType.Blob) {
                let blob = resource.getBlob().blobData;
                this.dataContext.logger.logDebug(`[Player]: Blob type "${blob.type}" of resource "${resource.resourceName}" will be loaded. Size: ${blob.size}`);
                let url = URL.createObjectURL(blob);
                this.dataContext.logger.logDebug(`[Player]: Blob url generated at ${url}`);
                audioSource.src = url;
                audioSource.type = blob.type;
            }
            audio.load();
            yield audio.play();
        });
    }
    shouldRender() {
        return true;
    }
}
exports.PlayerView = PlayerView;
//# sourceMappingURL=PlayerView.js.map